import React from "react";
import Header from "./Header";
import About from "./About";

function App() {
  return (
    <div className="App">
      <Header/>
      <About/>
      
    </div>
  );
}

export default App;
